/**
 * Registration form state + signup status flags (covers password signup
 * AND the Google signup prefill path). In-memory only; reload resets,
 * including the password field (which we never persist for any reason).
 */
class SignupStore {
  #listeners = new Set();

  // ── Registration form fields ───────────────────────────────────────────
  #regFirstName = "";
  #regLastName = "";
  #regEmail = "";
  #regPhone = "";
  #regPassword = "";
  #regStreet = "";
  #regCity = "";
  #regState = "";
  #registered = false;

  get regFirstName() { return this.#regFirstName; }
  set regFirstName(v) { this.#regFirstName = v; this.#notify(); }

  get regLastName() { return this.#regLastName; }
  set regLastName(v) { this.#regLastName = v; this.#notify(); }

  get regEmail() { return this.#regEmail; }
  set regEmail(v) { this.#regEmail = v; this.#notify(); }

  get regPhone() { return this.#regPhone; }
  set regPhone(v) { this.#regPhone = v; this.#notify(); }

  get regPassword() { return this.#regPassword; }
  set regPassword(v) { this.#regPassword = v; this.#notify(); }

  get regStreet() { return this.#regStreet; }
  set regStreet(v) { this.#regStreet = v; this.#notify(); }

  get regCity() { return this.#regCity; }
  set regCity(v) { this.#regCity = v; this.#notify(); }

  get regState() { return this.#regState; }
  set regState(v) { this.#regState = v; this.#notify(); }

  get registered() { return this.#registered; }
  set registered(v) { this.#registered = !!v; this.#notify(); }

  // ── Signup status flags ────────────────────────────────────────────────
  #signupLoading = false;
  #signupError = null;
  #signupDone = false;
  #needsSignupCompletion = false;
  #googleSignupLoading = false;
  #googleSignupError = null;

  get signupLoading() { return this.#signupLoading; }
  set signupLoading(v) { this.#signupLoading = !!v; this.#notify(); }

  get signupError() { return this.#signupError; }
  set signupError(v) { this.#signupError = v; this.#notify(); }

  get signupDone() { return this.#signupDone; }
  set signupDone(v) { this.#signupDone = !!v; this.#notify(); }

  get needsSignupCompletion() { return this.#needsSignupCompletion; }
  set needsSignupCompletion(v) { this.#needsSignupCompletion = !!v; this.#notify(); }

  get googleSignupLoading() { return this.#googleSignupLoading; }
  set googleSignupLoading(v) { this.#googleSignupLoading = !!v; this.#notify(); }

  get googleSignupError() { return this.#googleSignupError; }
  set googleSignupError(v) { this.#googleSignupError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#regFirstName = "";
    this.#regLastName = "";
    this.#regEmail = "";
    this.#regPhone = "";
    this.#regPassword = "";
    this.#regStreet = "";
    this.#regCity = "";
    this.#regState = "";
    this.#registered = false;
    this.#signupLoading = false;
    this.#signupError = null;
    this.#signupDone = false;
    this.#needsSignupCompletion = false;
    this.#googleSignupLoading = false;
    this.#googleSignupError = null;
    this.#notify();
  }
}

const signupStore = new SignupStore();
export default signupStore;
